import React, { useState } from 'react'
import './SubscribeForm.css'

const BlogSubscribeForm = () => {
    const [formData, setFormData] = useState({
        EMAIL: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault(); // prevent the default form behavior

        try {
            const response = await fetch('https://d427d68c.sibforms.com/serve/MUIFAC15XSWYpBQmNWqFuKgYW8srJIUpNhob-tcwaZQmnnI8yE6XgYWvsYN7adJ8XWoV9cbJONPQcQjps4iw1k_jEj-uU28JG_29M1Y1XXiiouZYbdY4eHvOE1D4zq9impKk537TcLbM6VkCmy7OpDEm5hiTP3TIQEPJyWDUWm6Jd3302ZBHf7YuOLm7pJAhUDbzMgMSUX-s3KqL', {
                method: 'POST',
                mode: 'no-cors',  // Important because Sendinblue won't return CORS headers
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData).toString(),
            });

            setSubmitted(true);
            setError('');

            // Reset form after 6 seconds
            setTimeout(() => {
                setSubmitted(false);
                setFormData({
                    EMAIL: ''
                });
            }, 6000); // 6 seconds delay
        } catch (err) {
            console.error('Error submitting the form:', err);
            setError('Something went wrong. Please try again.');
        }
    };

    return (
        <div className="blog-subscribe-wrapper">
            {submitted ? (
                <div className="thank-you-message">
                    <h1>Thank you for subscribing!</h1>
                </div>
            ) : (
                <form id="sub-form" onSubmit={handleSubmit} className="my-sub-form">

                    <div className='blog-mini-div'>
                        <h1>Discover More, Think Deeper</h1>
                        <p>Go beyond the headlines with educational posts, engaging life topics, and insightful
                            videos curated by the FNN team.</p>
                    </div>

                    <div className="sub-form-items-and-text">
                        <div className="sub-form-items">
                            {/* Email */}
                            <div className="sub-form-block">
                                <input
                                    className="subs-input"
                                    type="email"
                                    name="EMAIL"
                                    placeholder="Email"
                                    value={formData.EMAIL}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Submit Button */}
                            <button
                                className="subs-submit-button"
                                type="submit"
                            >
                                Send
                            </button>
                        </div>

                        <p>Join our Blog Newsletter to explore the ideas shaping resilience, climate tech, and the 
                        people shaping tomorrow. </p>
                    </div>

                    {error && <p className="error-message">{error}</p>}
                </form>
            )}
        </div>
    );

}

export default BlogSubscribeForm